import { InjectionToken, Provider } from '@angular/core';

import { HashFilesMap } from './hash-files.types';

export const ISS_HASH_FILES_MAP = new InjectionToken<HashFilesMap>('ISS_HASH_FILES_MAP');

export const hashFilesProvider = (useValue: HashFilesMap): Provider => ({
  provide: ISS_HASH_FILES_MAP,
  useValue,
});
